import { useSearchParams } from 'react-router-dom';

import { DateTime } from 'luxon';

export default function useDateQuery(param: string = 'date') {
	const [searchParams, setSearchParams] = useSearchParams();
	const date = searchParams.get(param);
	const dateTime = date ? DateTime.fromISO(date) : DateTime.now();
	return {
		date,
		setDate: (newDate: string) => setSearchParams({ date: newDate }),
		dateTime,
		setDateTime: (newDateTime: DateTime) => setSearchParams({ date: newDateTime.toISODate() }),
	};
}
